import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GalleryItem } from '../../types/gallery';
import { getOptimizedUrl as defaultGetOptimizedUrl } from '../../utils/utils';
import { saveMainPageScroll } from '../../utils/scrollRestoration';

export interface GridImageProps {
  item: GalleryItem;
  color?: string;
  getOptimizedUrl?: (path: string, width?: number) => string;
  onMouseEnter?: (item: GalleryItem, e: React.MouseEvent<HTMLImageElement>) => void;
  onMouseMove?: (e: React.MouseEvent<HTMLImageElement>) => void;
  onMouseLeave?: () => void;
  onClick?: (item: GalleryItem) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const GridImage: React.FC<GridImageProps> = ({
  item,
  color,
  getOptimizedUrl = defaultGetOptimizedUrl,
  onMouseEnter,
  onMouseMove,
  onMouseLeave,
  onClick,
  className = '',
  style
}) => {
  const navigate = useNavigate();

  let title = item.id.replace(/-qm/g, '?').replace(/-c/g, ':');
  if (title.includes('untitled')) title = title.replace(/_\d+/g, '');
  const altText = `schzstrg - ${title} (${item.year})`;
  const src = getOptimizedUrl(item.path, 1200);

  const handleClick = () => {
    // Save current scroll depth so back-navigation snaps to exact position
    saveMainPageScroll();
    if (onClick) {
      onClick(item);
    } else {
      navigate(`/gallery/${encodeURIComponent(item.id)}`);
    }
  };

  const colorAttr = color || item.color;
  return (
    <img
      src={src}
      alt={altText}
      className={`grid-image ${className}`}
      color={colorAttr}
      data-color={colorAttr}
      style={{
        cursor: 'zoom-in',
        ...style
      }}
      onClick={handleClick}
      onMouseEnter={(e) => onMouseEnter?.(item, e)}
      onMouseMove={(e) => onMouseMove?.(e)}
      onMouseLeave={() => onMouseLeave?.()}
      loading="lazy"
    />
  );
};

export default GridImage;
